export default __webpack_public_path__ + "fef0a0e48d5755b6bdf11afed8676963.png";